module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', [_c('v-card-title', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "mr-2",
    attrs: {
      "small": "",
      "icon": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('v-icon', [_vm._v("mdi-close")])], 1)], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "pt-0"
  }, [(_vm.typeError === 'validation_excel') ? _c('div', {
    staticClass: "text-center"
  }, [_c('div', {
    staticClass: "font-weight-bold black--text mb-1",
    staticStyle: {
      "font-size": "18px"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.liveClassTotalErrorExcel || 0) + " dari\n                " + _vm._s(_vm.liveClassData.length || 0) + "\n                Data Live Class Bermasalah\n            ")]), _vm._v(" "), _c('div', [_vm._v("\n                Kami menemukan eror pada berkas live class data Anda.\n                Silahkan perbaiki sesuai detail kesalahan yang tertera.\n            ")])]) : _vm._e(), _vm._v(" "), (_vm.typeError === 'upload_excel') ? _c('div', {
    staticClass: "text-center"
  }, [_c('div', {
    staticClass: "mb-5",
    attrs: {
      "align": "center"
    }
  }, [_c('v-img', {
    attrs: {
      "src": require('@/assets/img/failed.svg'),
      "height": "90",
      "width": "90"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "font-weight-bold black--text mb-1",
    staticStyle: {
      "font-size": "18px"
    }
  }, [_vm._v("\n                Gagal Memproses " + _vm._s(_vm.liveClassTotalErrorExcel || 0) + " Data\n            ")]), _vm._v(" "), _c('div', [_vm._v("\n                Kami menemukan eror pada berkas live class data Anda.\n                Silahkan perbaiki sesuai detail kesalahan yang tertera.\n            ")])]) : _vm._e(), _vm._v(" "), _c('v-card', {
    staticClass: "mt-7",
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-text', {
    staticClass: "px-0"
  }, [_c('div', {
    staticClass: "font-weight-bold px-2 pb-4 black--text d-flex align-center"
  }, [_c('div', [_c('v-img', {
    staticClass: "mr-1",
    attrs: {
      "src": require('@/assets/img/list_failed.svg'),
      "contain": "",
      "height": "35"
    }
  })], 1), _vm._v("\n\n                    " + _vm._s(_vm.liveClassTotalErrorExcel) + " data live class gagal\n                    diproses\n                ")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-simple-table', {
    attrs: {
      "fixed-header": "",
      "height": "285px"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Baris")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "40%"
    }
  }, [_vm._v("Nama")]), _vm._v(" "), _c('th', [_vm._v("Status")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "35%"
    }
  }, [_vm._v("Detail Kesalahan")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.liveClassExcelError), function(data) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(data.baris))]), _vm._v(" "), _c('td', [_vm._v("\n                                " + _vm._s(data.judul_live_class ||
      "Tidak ada judul") + "\n                            ")]), _vm._v(" "), _c('td', [_c('v-btn', {
      staticClass: "error--text",
      attrs: {
        "rounded": "",
        "small": "",
        "depressed": "",
        "color": "#f7d5d5"
      }
    }, [_vm._v("\n                                    Gagal\n                                ")])], 1), _vm._v(" "), _c('td', {
      staticClass: "py-3",
      domProps: {
        "innerHTML": _vm._s(data.error)
      }
    })])
  }), 0)])], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), (_vm.typeError === 'upload_excel') ? _c('v-btn', {
    attrs: {
      "color": "blew",
      "depressed": "",
      "dark": "",
      "loading": _vm.loadingExport
    },
    on: {
      "click": function($event) {
        return _vm.exportToExcel()
      }
    }
  }, [_vm._v("\n            Download File\n        ")]) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-127fc8bb","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/live_class/components/DialogExcelErrorUpload.vue
// module id = 1672
// module chunks = 1